import HttpService from "./http.service";
import axios from "axios";

class CrudService {
  // users requests
  imageUpload = async (formData, id) => {
    const imageUpdate = `upload-api/users/${id}/profile-image`;
    return await HttpService.post(imageUpdate, formData);
  };

  getUsers = async () => {
    const usersEndpoint = "users?include=roles";
    return await HttpService.get(usersEndpoint);
  };

  deleteUser = async (id) => {
    const endpoint = `users/${id}`;
    return await HttpService.delete(endpoint);
  };

  createUser = async (payload) => {
    const endpoint = "users";
    return await HttpService.post(endpoint, payload);
  };

  getUser = async (id) => {
    const endpoint = `users/${id}?include=roles`;
    return await HttpService.get(endpoint);
  };

  getUserWithPermissions = async (id) => {
    const endpoint = `users/${id}?include=roles,roles.permissions`;
    return await HttpService.get(endpoint);
  };

  updateUser = async (payload, id) => {
    const endpoint = `users/${id}`;
    return await HttpService.patch(endpoint, payload);
  };

  // roles requests
  getRoles = async () => {
    const rolesEndpoint = "roles";
    return await HttpService.get(rolesEndpoint);
  };

  deleteRole = async (id) => {
    const endpoint = `roles/${id}`;
    return await HttpService.delete(endpoint);
  };

  createRole = async (payload) => {
    const endpoint = "roles";
    return await HttpService.post(endpoint, payload);
  };

  updateRole = async (payload, id) => {
    const endpoint = `roles/${id}`;
    return await HttpService.patch(endpoint, payload);
  };

  getRole = async (id) => {
    const endpoint = `roles/${id}`;
    return await HttpService.get(endpoint);
  };

  // categories requests
  getCategories = async () => {
    const categoriesEndpoint = "categories";
    return await HttpService.get(categoriesEndpoint);
  };

  deleteCategory = async (id) => {
    const endpoint = `categories/${id}`;
    return await HttpService.delete(endpoint);
  };

  createCategory = async (payload) => {
    const endpoint = "categories";
    return await HttpService.post(endpoint, payload);
  };

  getCategory = async (id) => {
    const categoriesEndpoint = `categories/${id}`;
    return await HttpService.get(categoriesEndpoint);
  };

  updateCategory = async (payload, id) => {
    const categoriesEndpoint = `categories/${id}`;
    return await HttpService.patch(categoriesEndpoint, payload);
  };



  getStrategies = async () => {
    const strategiesEndpoint = "strategy";
    return await HttpService.get(strategiesEndpoint);
  };

  deleteStrategy = async (id) => {
    try {
      const response = await HttpService.delete(`strategy/${id}`);
      return response;
    } catch (error) {
      console.error("Error deleting strategy:", error);
      throw error;
    }
  };

  getStrategyNumber = async () => {
    const endpoint = "strategy/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  createStrategy = async (payload) => {
    const endpoint = "strategy";
    return await HttpService.post(endpoint, payload);
  };

  getStrategy = async (id) => {
    const strategiesEndpoint = `/strategies/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(strategiesEndpoint);
  };

  getStrategyById = async (id) => {
    try {
      const response = await HttpService.get(`/strategy/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getStrategyById:", error.message);
      throw error;
    }
  };

  updateStrategy = async (strategy, strategyId) => {
    const endpoint = `strategy/${strategyId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, strategy); // PUT veya PATCH kullanın
  };

  // Müşteri öneki ile eşleşen kayıtları getiren fonksiyon
  getStrategiesByPrefix = async (prefix) => {
    const endpoint = `strategy?prefix=${prefix}`; // Backend'deki uygun endpoint'e göre URL'yi güncelleyin
    try {
      const response = await HttpService.get(endpoint);
      return response.data; // Veriyi döndür
    } catch (error) {
      console.error("Error fetching strategies by prefix:", error.message);
      throw error;
    }
  };


  getProspectLists = async () => {
    const endpoint = "prospect-lists";
    return await HttpService.get(endpoint);
  };

  deleteProspectList = async (id) => {
    try {
      const response = await HttpService.delete(`prospect-lists/${id}`);
      return response;
    } catch (error) {
      console.error("Error deleting target customer list:", error);
      throw error;
    }
  };

  getProspectListNumber = async () => {
    const endpoint = "prospect-lists/number";          // böyle bir route varsa
    return await HttpService.get(endpoint);
  };

  createProspectList = async (payload) => {
    const endpoint = "prospect-lists";
    return await HttpService.post(endpoint, payload);
  };

  getProspectList = async (id) => {                    // tekil kayıt
    const endpoint = `prospect-lists/${id}`;
    return await HttpService.get(endpoint);
  };

  // Yukarıdaki fonksiyon tek başına yeterli olduğu için ikinci bir kopyaya gerek yok,
  // ancak ihtiyaç varsa isim değiştirerek kullanabilirsiniz.
  getProspectListById = async (id) => {
    try {
      const response = await HttpService.get(`prospect-lists/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getProspectListById:", error.message);
      throw error;
    }
  };

  updateProspectList = async (data, id) => {
    const endpoint = `prospect-lists/${id}`;
    return await HttpService.patch(endpoint, data);    // PATCH veya PUT
  };

  // Prefix ile arama
  getProspectListsByPrefix = async (prefix) => {
    const endpoint = `prospect-lists?prefix=${prefix}`;
    try {
      const response = await HttpService.get(endpoint);
      return response.data;
    } catch (error) {
      console.error("Error fetching target customer lists by prefix:", error.message);
      throw error;
    }
  };


  getTargets = async () => {
    return await HttpService.get("/target");
  };


  deleteTarget = async (id) => {
    try {
      const response = await HttpService.delete(`target/${id}`);
      return response;
    } catch (error) {
      console.error("Error deleting target:", error);
      throw error;
    }
  };

  getTargetNumber = async () => {
    const endpoint = "target/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  createTarget = async (payload) => {
    const endpoint = "target";
    return await HttpService.post(endpoint, payload);
  };

  getTarget = async (id) => {
    const targetEndpoint = `/targets/${id}`;
    return await HttpService.get(targetEndpoint);
  };

  getTargetById = async (id) => {
    try {
      const response = await HttpService.get(`/target/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getTargetById:", error.message);
      throw error;
    }
  };

  updateTarget = async (target, targetId) => {
    const endpoint = `target/${targetId}`;
    return await HttpService.patch(endpoint, target); // PUT veya PATCH kullanın
  };
  getTargetsByPrefix = async (prefix) => {
    const endpoint = `target?prefix=${prefix}`; // Backend'deki uygun endpoint'e göre URL'yi güncelleyin
    try {
      const response = await HttpService.get(endpoint);
      return response.data; // Veriyi döndür
    } catch (error) {
      console.error("Error fetching targets by prefix:", error.message);
      throw error;
    }
  };

  getCustomers = async (params = {}) => {
    const customersEndpoint = "customer";
    return await HttpService.get(customersEndpoint, { params });
  };

  deleteCustomer = async (id) => {
    try {
      const response = await HttpService.delete(`customer/${id}`);
      return response;
    } catch (error) {
      console.error("Error deleting customer:", error);
      throw error;
    }
  };

  getCustomerNumber = async () => {
    const endpoint = "customer/number";
    return await HttpService.get(endpoint);
  };

  createCustomer = async (payload) => {
    const endpoint = "customer";
    return await HttpService.post(endpoint, payload);
  };

  getCustomer = async (id) => {
    const customersEndpoint = `/customers/${id}`;
    return await HttpService.get(customersEndpoint);
  };

  getCustomerById = async (id) => {
    try {
      const response = await HttpService.get(`/customer/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getCustomerById:", error.message);
      throw error;
    }
  };

  updateCustomer = async (customer, customerId) => {
    const endpoint = `customer/${customerId}`;
    return await HttpService.patch(endpoint, customer);
  };

  getCustomersByPrefix = async (prefix) => {
    const endpoint = `customer?prefix=${prefix}`;
    try {
      const response = await HttpService.get(endpoint);
      return response.data;
    } catch (error) {
      console.error("Error fetching customers by prefix:", error.message);
      throw error;
    }
  };




  getProspectCustomers = async () => {
    const customersEndpoint = "prospect-customer";
    return await HttpService.get(customersEndpoint);
  };

  // Belirli bir shipment'ı silen fonksiyon
  deleteProspectCustomer = async (id) => {
    try {
      const response = await HttpService.delete(`prospect-customer/${id}`); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting customer:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getProspectCustomerNumber = async () => {
    const endpoint = "prospect-customer/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createProspectCustomer = async (payload) => {
    const endpoint = "prospect-customer"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getProspectCustomer = async (id) => {
    const customersEndpoint = `/prospect-customers/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(customersEndpoint);
  };

  getProspectCustomerById = async (id) => {
    try {
      const response = await HttpService.get(`/prospect-customer/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getCustomerById:", error.message);
      throw error;
    }
  };


  // Shipment güncelleme fonksiyonu
  updateProspectCustomer = async (customer, customerId) => {
    const endpoint = `prospect-customer/${customerId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, customer); // PUT veya PATCH kullanın
  };

  // Müşteri öneki ile eşleşen kayıtları getiren fonksiyon
  getProspectCustomersByPrefix = async (prefix) => {
    const endpoint = `prospect-customer?prefix=${prefix}`; // Backend'deki uygun endpoint'e göre URL'yi güncelleyin
    try {
      const response = await HttpService.get(endpoint);
      return response.data; // Veriyi döndür
    } catch (error) {
      console.error("Error fetching customers by prefix:", error.message);
      throw error;
    }
  };

  getServiceProviders = async () => {
    const serviceProvidersEndpoint = "serviceProvider";
    return await HttpService.get(serviceProvidersEndpoint);
  };

  // Belirli bir shipment'ı silen fonksiyon
  deleteServiceProvider = async (id) => {
    try {
      const response = await HttpService.delete(`serviceProvider/${id}`); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting serviceProvider:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getServiceProviderNumber = async () => {
    const endpoint = "serviceProvider/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createServiceProvider = async (payload) => {
    const endpoint = "serviceProvider"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getServiceProvider = async (id) => {
    const serviceProvidersEndpoint = `/serviceProviders/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(serviceProvidersEndpoint);
  };

  getServiceProviderById = async (id) => {
    try {
      const response = await HttpService.get(`/serviceProvider/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getserviceProviderById:", error.message);
      throw error;
    }
  };


  // Shipment güncelleme fonksiyonu
  updateServiceProvider = async (serviceProvider, serviceProviderId) => {
    const endpoint = `serviceProvider/${serviceProviderId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, serviceProvider); // PUT veya PATCH kullanın
  };

  // Müşteri öneki ile eşleşen kayıtları getiren fonksiyon
  getServiceProvidersByPrefix = async (prefix) => {
    const endpoint = `serviceProvider?prefix=${prefix}`; // Backend'deki uygun endpoint'e göre URL'yi güncelleyin
    try {
      const response = await HttpService.get(endpoint);
      return response.data; // Veriyi döndür
    } catch (error) {
      console.error("Error fetching service Providers by prefix:", error.message);
      throw error;
    }
  };



  getGlobalAgents = async () => {
    const globalAgentsEndpoint = "globalAgent";
    return await HttpService.get(globalAgentsEndpoint);
  };

  // Belirli bir shipment'ı silen fonksiyon
  deleteGlobalAgent = async (id) => {
    try {
      const response = await HttpService.delete(`globalAgent/${id}`); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting globalAgent:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getGlobalAgentNumber = async () => {
    const endpoint = "globalAgent/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createGlobalAgent = async (payload) => {
    const endpoint = "globalAgent"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getGlobalAgent = async (id) => {
    const globalAgentsEndpoint = `/globalAgents/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(globalAgentsEndpoint);
  };

  getGlobalAgentById = async (id) => {
    try {
      const response = await HttpService.get(`/globalAgent/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getglobalAgentById:", error.message);
      throw error;
    }
  };


  // Shipment güncelleme fonksiyonu
  updateGlobalAgent = async (globalAgent, globalAgentId) => {
    const endpoint = `globalAgent/${globalAgentId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, globalAgent); // PUT veya PATCH kullanın
  };

  // Müşteri öneki ile eşleşen kayıtları getiren fonksiyon
  getGlobalAgentsByPrefix = async (prefix) => {
    const endpoint = `globalAgent?prefix=${prefix}`; // Backend'deki uygun endpoint'e göre URL'yi güncelleyin
    try {
      const response = await HttpService.get(endpoint);
      return response.data; // Veriyi döndür
    } catch (error) {
      console.error("Error fetching globalAgent by prefix:", error.message);
      throw error;
    }
  };

  bulkCreateGlobalAgents = async (data) => {
    const endpoint = "globalAgent/bulk";
    try {
      const response = await HttpService.post(endpoint, data);
      return response.data;
    } catch (error) {
      console.error("Error in bulkCreateGlobalAgents:", error.message);
      throw error;
    }
  };



  getOpportunities = async () => {
    const opportunitiesEndpoint = "opportunity";
    return await HttpService.get(opportunitiesEndpoint);
  };

  // Belirli bir shipment'ı silen fonksiyon
  deleteOpportunity = async (id) => {
    try {
      const response = await HttpService.delete(`opportunity/${id}`); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting opportunity:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getOpportunityNumber = async () => {
    const endpoint = "opportunity/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createOpportunity = async (payload) => {
    const endpoint = "opportunity"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getOpportunity = async (id) => {
    const opportunitiesEndpoint = `/meetings/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(opportunitiesEndpoint);
  };

  getOpportunityById = async (id) => {
    try {
      const response = await HttpService.get(`/opportunity/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getOpportunityById:", error.message);
      throw error;
    }
  };


  // Shipment güncelleme fonksiyonu
  updateOpportunity = async (opportunity, opportunityId) => {
    const endpoint = `opportunity/${opportunityId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, opportunity); // PUT veya PATCH kullanın
  };

  // Müşteri öneki ile eşleşen kayıtları getiren fonksiyon
  getOpportunitiesByPrefix = async (prefix) => {
    const endpoint = `meeting?prefix=${prefix}`; // Backend'deki uygun endpoint'e göre URL'yi güncelleyin
    try {
      const response = await HttpService.get(endpoint);
      return response.data; // Veriyi döndür
    } catch (error) {
      console.error("Error fetching opportunities by prefix:", error.message);
      throw error;
    }
  };



  getMeetings = async () => {
    const meetingsEndpoint = "meeting";
    return await HttpService.get(meetingsEndpoint);
  };

  // Belirli bir shipment'ı silen fonksiyon
  deleteMeeting = async (id) => {
    try {
      const response = await HttpService.delete(`meeting/${id}`); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting meeting:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getMeetingNumber = async () => {
    const endpoint = "meeting/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createMeeting = async (payload) => {
    const endpoint = "meeting"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getMeeting = async (id) => {
    const meetingsEndpoint = `/meetings/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(meetingsEndpoint);
  };

  getMeetingById = async (id) => {
    try {
      const response = await HttpService.get(`/meeting/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getMeetingById:", error.message);
      throw error;
    }
  };


  // Shipment güncelleme fonksiyonu
  updateMeeting = async (meeting, meetingId) => {
    const endpoint = `meeting/${meetingId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, meeting); // PUT veya PATCH kullanın
  };

  // Müşteri öneki ile eşleşen kayıtları getiren fonksiyon
  getMeetingsByPrefix = async (prefix) => {
    const endpoint = `meeting?prefix=${prefix}`; // Backend'deki uygun endpoint'e göre URL'yi güncelleyin
    try {
      const response = await HttpService.get(endpoint);
      return response.data; // Veriyi döndür
    } catch (error) {
      console.error("Error fetching meetings by prefix:", error.message);
      throw error;
    }
  };

  getLeads = async () => {
    const endpoint = "salesLead";
    return await HttpService.get(endpoint);
  };

// Lead silme
  deleteLead = async (id) => {
    try {
      const response = await HttpService.delete(`salesLead/${id}`);
      return response;
    } catch (error) {
      console.error("Error deleting lead:", error);
      throw error;
    }
  };

// Lead number almak (eğer backend'de /lead/number endpoint'i yazarsak)
  getLeadNumber = async () => {
    const endpoint = "salesLead/number";
    return await HttpService.get(endpoint);
  };

// Lead oluşturma
  createLead = async (payload) => {
    const endpoint = "salesLead";
    return await HttpService.post(endpoint, payload);
  };

// ❗️Bu fonksiyon meeting tarafında hatalı/karışık endpoint kullanıyor.
// Lead'de düzgün yapalım:
  getLeadById = async (id) => {
    try {
      const response = await HttpService.get(`/salesLead/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getLeadById:", error.message);
      throw error;
    }
  };

// Lead güncelleme
  updateLead = async (lead, leadId) => {
    const endpoint = `salesLead/${leadId}`;
    return await HttpService.patch(endpoint, lead);
  };

// Prefix ile lead arama
  getLeadsByPrefix = async (prefix) => {
    const endpoint = `salesLead?prefix=${prefix}`;
    try {
      const response = await HttpService.get(endpoint);
      return response.data;
    } catch (error) {
      console.error("Error fetching leads by prefix:", error.message);
      throw error;
    }
  };



  getCompetitors = async () => {
    const competitorsEndpoint = "competitor";
    return await HttpService.get(competitorsEndpoint);
  };

  // Belirli bir shipment'ı silen fonksiyon
  deleteCompetitor = async (id) => {
    try {
      const response = await HttpService.delete(`competitor/${id}`); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting competitor:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getCompetitorNumber = async () => {
    const endpoint = "competitor/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createCompetitor = async (payload) => {
    const endpoint = "competitor"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getCompetitor = async (id) => {
    const competitorsEndpoint = `/competitors/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(competitorsEndpoint);
  };

  getCompetitorById = async (id) => {
    try {
      const response = await HttpService.get(`/competitor/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getCompetitorById:", error.message);
      throw error;
    }
  };

  updateCompetitor = async (competitor, competitorId) => {
    const endpoint = `competitor/${competitorId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, competitor); // PUT veya PATCH kullanın
  };

  // Müşteri öneki ile eşleşen kayıtları getiren fonksiyon
  getCompetitorsByPrefix = async (prefix) => {
    const endpoint = `competitor?prefix=${prefix}`; // Backend'deki uygun endpoint'e göre URL'yi güncelleyin
    try {
      const response = await HttpService.get(endpoint);
      return response.data; // Veriyi döndür
    } catch (error) {
      console.error("Error fetching competitors by prefix:", error.message);
      throw error;
    }
  };



  getConsolidations = async () => {
    const consolidationEndpoint = "consolidation";
    return await HttpService.get(consolidationEndpoint);
  };

  createConsolidation = async (payload) => {
    const endpoint = "consolidation"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  deleteConsolidation = async (id) => {
    try {
      const response = await HttpService.delete(`consolidation/${id}`); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting consolidate:", error);
      throw error;
    }
  };

  updateConsolidation = async (consolidation, consolidationId) => {
    const endpoint = `consolidation/${consolidationId}`; // Konsolidasyon endpoint'i
    const payload = {
      data: consolidation, // Backend'in beklediği "data" anahtarını ekliyoruz
    };

    return await HttpService.patch(endpoint, payload); // PATCH isteği gönderiliyor
  };


  getQuotingTools = async () => {
    const quotingToolsEndpoint = "quotingTool";
    return await HttpService.get(quotingToolsEndpoint);
  };

  // Belirli bir shipment'ı silen fonksiyon
  deleteQuotingTool = async (id) => {
    try {
      const response = await HttpService.delete(`quotingTool/${id}`); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting quotingTool:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getQuotingToolNumber = async () => {
    const endpoint = "quotingTool/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createQuotingTool = async (payload) => {
    const endpoint = "quotingTool"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getQuotingTool = async (id) => {
    const quotingToolsEndpoint = `/quotingTools/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(quotingToolsEndpoint);
  };

  getQuotingToolById = async (id) => {
    try {
      const response = await HttpService.get(`/quotingTool/${id}`);
      return response;
    } catch (error) {
      console.error("Error in getQuotingToolById:", error.message);
      throw error; // Hatanın yukarıya iletilmesi
    }
  };


  // Shipment güncelleme fonksiyonu
  updateQuotingTool = async (quotingTool, quotingToolId) => {
    const endpoint = `quotingTool/${quotingToolId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, quotingTool); // PUT veya PATCH kullanın
  };


  // Tüm shipment'ları getiren fonksiyon
  getShipments = async () => {
    const shipmentsEndpoint = "shipment";
    return await HttpService.get(shipmentsEndpoint);
  };

  // Belirli bir shipment'ı silen fonksiyon
  // rmblAction: "delete" also removes an RMBL left without shipments; otherwise it stays for another RHFL.
  deleteShipment = async (id, rmblAction) => {
    try {
      const response = await HttpService.delete(`shipment/${id}`, rmblAction ? { params: { rmbl: rmblAction } } : {}); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting shipment:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getShipmentNumber = async () => {
    const endpoint = "shipment/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createShipment = async (payload) => {
    const endpoint = "shipment"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getShipment = async (id) => {
    const shipmentsEndpoint = `/shipments/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(shipmentsEndpoint);
  };

  getShipmentById = async (id) => {
    if (!id || id.length !== 24) {
      throw new Error("Invalid shipment ID provided.");
    }

    try {
      const response = await HttpService.get(`/shipment/${id}`);
      return response;
    } catch (error) {
      console.error("Error fetching shipment by ID:", error);
      throw error; // Hatanın üst seviyede yakalanması için fırlatılıyor
    }
  };

  // Shipment güncelleme fonksiyonu
  updateShipment = async (shipment, shipmentId) => {
    const endpoint = `shipment/${shipmentId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, shipment); // PUT veya PATCH kullanın
  };

  // Corrects plate / trailer / driver / CMR / seal of an RHFL's trucks (from its RMBL).
  updateShipmentTrucks = async (shipmentId, trucks) =>
    HttpService.patch(`shipment/${shipmentId}/trucks`, { trucks });


  // ==== MBL CRUD ====

// Get all MBLs
  getMBLs = async () => {
    const endpoint = "mbl";
    return await HttpService.get(endpoint);
  };
// Get MBL by id
  getMBLById = async (id) => {
    if (!id || id.length !== 24) throw new Error("Invalid mbl ID provided.");
    return await HttpService.get(`/mbl/${id}`);
  };

// Create MBL (FormData veya json)
  createMBL = async (formData) => {
    // HttpService bazen JSON header basıyorsa burada direkt axios kullan
    return await HttpService.post("mbl", formData, {
      // ÖNEMLİ: content-type set ETME
      headers: {},
    });
  };

// Update MBL
  updateMBL = async (payload, mblId) => {
    const endpoint = `mbl/${mblId}`;
    return await HttpService.patch(endpoint, payload);
  };

// Delete MBL
  deleteMBL = async (id) => {
    return await HttpService.delete(`mbl/${id}`);
  };

// Add location history to MBL
  addMBLLocationHistory = async (mblId, { label, lat, lon }) => {
    return await HttpService.post(`mbl/${mblId}/add-location-history`, { label, lat, lon });
  };

// Add location history to a Shipment
  addShipmentLocationHistory = async (shipmentId, { label, lat, lon }) => {
    return await HttpService.post(`shipment/${shipmentId}/add-location-history`, { label, lat, lon });
  };

  getNextRMBLNumber = async () => {
    const endpoint = "mbl/next-rmbl-number";
    return await HttpService.get(endpoint);
  };

  getOMBLs = async (params = {}) => {
    const shipmentId = String(params.shipmentId || "").trim();
    return await HttpService.get(shipmentId ? `ombl?shipmentId=${encodeURIComponent(shipmentId)}` : "ombl");
  };

  getOMBLById = async (id) => {
    if (!id || id.length !== 24) throw new Error("Invalid ombl ID provided.");
    return await HttpService.get(`/ombl/${id}`);
  };

  createOMBL = async (formData) => {
    return await HttpService.post("ombl", formData, {
      headers: {},
    });
  };

  updateOMBL = async (payload, omblId) => {
    return await HttpService.patch(`ombl/${omblId}`, payload);
  };

  // Stores carrier MBL / booking numbers per container without changing other OMBL fields.
  updateOMBLCarrierReferences = async (omblId, carrierReferences) => {
    return await HttpService.patch(`ombl/${omblId}/carrier-references`, { data: { carrierReferences } });
  };

  deleteOMBL = async (id) => {
    return await HttpService.delete(`ombl/${id}`);
  };

  getNextOMBLNumber = async () => {
    return await HttpService.get("ombl/next-ombl-number");
  };
  // Tüm shipment'ları getiren fonksiyon
  getOceanShipments = async () => {
    const shipmentsEndpoint = "ocean-shipment";
    return await HttpService.get(shipmentsEndpoint);
  };

  // Belirli bir shipment'ı silen fonksiyon
  // omblAction: "delete" also removes an OMBL left without shipments; otherwise it stays for another HBL.
  deleteOceanShipment = async (id, omblAction) => {
    try {
      const response = await HttpService.delete(`ocean-shipment/${id}`, omblAction ? { params: { ombl: omblAction } } : {}); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting ocean shipment:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getOceanShipmentNumber = async () => {
    const endpoint = "ocean-shipment/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createOceanShipment = async (payload) => {
    const endpoint = "ocean-shipment"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getOceanShipment = async (id) => {
    const shipmentsEndpoint = `/ocean-shipments/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(shipmentsEndpoint);
  };

  // Ocean Shipment Status (carrier API container tracking)
  getOceanTrackingCarriers = async () => await HttpService.get("ocean-tracking/carriers");

  getOceanTrackings = async (params = {}) => await HttpService.get("ocean-tracking", { params });

  getOceanTracking = async (id) => await HttpService.get(`ocean-tracking/${id}`);

  createOceanTrackings = async (payload) => await HttpService.post("ocean-tracking", payload);

  refreshOceanTracking = async (id) => await HttpService.post(`ocean-tracking/${id}/refresh`, {});

  updateOceanTracking = async (id, payload) => await HttpService.patch(`ocean-tracking/${id}`, payload);

  deleteOceanTracking = async (id) => await HttpService.delete(`ocean-tracking/${id}`);

  // Route stops, carrier-reported and live AIS vessel position for the status map.
  getOceanTrackingMap = async (id) => await HttpService.get(`ocean-tracking/${id}/map`);

  // Read-only carrier lookup used to prefill Create Ocean Shipment.
  lookupOceanTracking = async (params) => await HttpService.get("ocean-tracking/lookup", { params });

  // File > Notifications (ocean, air, road): settings, container dates / free time, history and approvals.
  // mode: "OCEAN" (default), "AIR" or "ROAD".
  shipmentNotificationsPath = (shipmentId, mode = "OCEAN") =>
    mode && mode !== "OCEAN"
      ? `shipment-notifications/${mode.toLowerCase()}/${shipmentId}`
      : `shipment-notifications/${shipmentId}`;

  getShipmentNotifications = async (shipmentId, mode) => await HttpService.get(this.shipmentNotificationsPath(shipmentId, mode));

  updateShipmentNotificationSettings = async (shipmentId, rows, mode) =>
    await HttpService.put(`${this.shipmentNotificationsPath(shipmentId, mode)}/settings`, { rows });

  resetShipmentNotificationSettings = async (shipmentId, mode) =>
    await HttpService.post(`${this.shipmentNotificationsPath(shipmentId, mode)}/settings/reset`, {});

  updateShipmentContainerStatus = async (shipmentId, containerNumber, payload) =>
    await HttpService.put(`shipment-notifications/${shipmentId}/containers/${encodeURIComponent(containerNumber)}`, payload);

  runShipmentNotifications = async (shipmentId, mode) =>
    await HttpService.post(`${this.shipmentNotificationsPath(shipmentId, mode)}/run`, {});

  getShipmentNotificationApprovals = async (params = {}) => await HttpService.get("shipment-notifications/approvals", { params });

  approveShipmentNotification = async (logId, payload = {}) =>
    await HttpService.post(`shipment-notifications/logs/${logId}/approve`, payload);

  rejectShipmentNotification = async (logId, reason = "") =>
    await HttpService.post(`shipment-notifications/logs/${logId}/reject`, { reason });

  getCustomerNotificationProfile = async (customerId) => await HttpService.get(`shipment-notifications/profiles/${customerId}`);

  updateCustomerNotificationProfile = async (customerId, rows) =>
    await HttpService.put(`shipment-notifications/profiles/${customerId}`, { rows });

  getOceanShipmentById = async (id) => {
    if (!id || id.length !== 24) {
      throw new Error("Invalid ocean shipment ID provided.");
    }

    try {
      const response = await HttpService.get(`/ocean-shipment/${id}`);
      return response;
    } catch (error) {
      console.error("Error fetching ocean shipment by ID:", error);
      throw error; // Hatanın üst seviyede yakalanması için fırlatılıyor
    }
  };

  // Shipment güncelleme fonksiyonu
  updateOceanShipment = async (shipment, shipmentId) => {
    const endpoint = `ocean-shipment/${shipmentId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, shipment); // PUT veya PATCH kullanın
  };



  getAMBLs = async (params = {}) => {
    const shipmentId = String(params.shipmentId || "").trim();
    return await HttpService.get(shipmentId ? `ambl?shipmentId=${encodeURIComponent(shipmentId)}` : "ambl");
  };

  getAMBLById = async (id) => {
    if (!id || id.length !== 24) throw new Error("Invalid ambl ID provided.");
    return await HttpService.get(`/ambl/${id}`);
  };

  createAMBL = async (formData) => {
    return await HttpService.post("ambl", formData, {
      headers: {},
    });
  };

  updateAMBL = async (payload, amblId) => {
    return await HttpService.patch(`ambl/${amblId}`, payload);
  };

  deleteAMBL = async (id) => {
    return await HttpService.delete(`ambl/${id}`);
  };

  getNextAMBLNumber = async () => {
    return await HttpService.get("ambl/next-ambl-number");
  };
  // Tüm shipment'ları getiren fonksiyon
  getAirShipments = async () => {
    const shipmentsEndpoint = "air-shipment";
    return await HttpService.get(shipmentsEndpoint);
  };

  // Belirli bir shipment'ı silen fonksiyon
  deleteAirShipment = async (id) => {
    try {
      const response = await HttpService.delete(`air-shipment/${id}`); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting air shipment:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getAirShipmentNumber = async () => {
    const endpoint = "air-shipment/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createAirShipment = async (payload) => {
    const endpoint = "air-shipment"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getAirShipment = async (id) => {
    const shipmentsEndpoint = `/air-shipments/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(shipmentsEndpoint);
  };

  getAirShipmentById = async (id) => {
    if (!id || id.length !== 24) {
      throw new Error("Invalid air shipment ID provided.");
    }

    try {
      const response = await HttpService.get(`/air-shipment/${id}`);
      return response;
    } catch (error) {
      console.error("Error fetching air shipment by ID:", error);
      throw error; // Hatanın üst seviyede yakalanması için fırlatılıyor
    }
  };

  // Shipment güncelleme fonksiyonu
  updateAirShipment = async (shipment, shipmentId) => {
    const endpoint = `air-shipment/${shipmentId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, shipment); // PUT veya PATCH kullanın
  };


  getAnnualLeaveRequests = async () => {
    const endpoint = "annual-leave-request";
    return await HttpService.get(endpoint);
  };

  getAnnualLeaveRequestById = async (id) => {
    if (!id || id.length !== 24) {
      throw new Error("Invalid annual leave request ID provided.");
    }

    try {
      const response = await HttpService.get(`/annual-leave-request/${id}`);
      return response;
    } catch (error) {
      console.error("Error fetching annual leave request by ID:", error);
      throw error;
    }
  };

  createAnnualLeaveRequest = async (payload) => {
    const endpoint = "annual-leave-request";
    return await HttpService.post(endpoint, payload);
  };

  updateAnnualLeaveRequest = async (payload, requestId) => {
    const endpoint = `annual-leave-request/${requestId}`;
    return await HttpService.patch(endpoint, payload);
  };

  approveAnnualLeaveRequest = async (id, payload = {}) => {
    if (!id || id.length !== 24) {
      throw new Error("Invalid annual leave request ID provided.");
    }

    const endpoint = `annual-leave-request/${id}/approve`;
    return await HttpService.patch(endpoint, payload);
  };

  rejectAnnualLeaveRequest = async (id, payload = {}) => {
    if (!id || id.length !== 24) {
      throw new Error("Invalid annual leave request ID provided.");
    }

    const endpoint = `annual-leave-request/${id}/reject`;
    return await HttpService.patch(endpoint, payload);
  };

  deleteAnnualLeaveRequest = async (id) => {
    if (!id || id.length !== 24) {
      throw new Error("Invalid annual leave request ID provided.");
    }

    try {
      const response = await HttpService.delete(`annual-leave-request/${id}`);
      return response;
    } catch (error) {
      console.error("Error deleting annual leave request:", error);
      throw error;
    }
  };

  uploadAnnualLeaveDocument = async (id, payload) => {
    return await HttpService.patch(
        `annual-leave-request/${id}/document`,
        payload
    );
  };

  // Tüm shipment'ları getiren fonksiyon
  getSpotQuotingTools = async () => {
    const spotQuotingToolsEndpoint = "spotQuotingTool";
    return await HttpService.get(spotQuotingToolsEndpoint);
  };

  deleteSpotQuotingTool = async (id) => {
    try {
      const response = await HttpService.delete(`spotQuotingTool/${id}`);
      return response;
    } catch (error) {
      console.error("Error deleting spotQuotingTool:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getSpotQuotingToolNumber = async () => {
    const endpoint = "spotQuotingTool/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createSpotQuotingTool = async (payload) => {
    const endpoint = "spotQuotingTool";
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getSpotQuotingTool = async (id) => {
    const spotQuotingToolsEndpoint = `/spotQuotingTools/${id}`;
    return await HttpService.get(spotQuotingToolsEndpoint);
  };

  getSpotQuotingToolById = async (id) => {
    if (!id || id.length !== 24) {
      throw new Error("Invalid spotQuotingTool ID provided.");
    }

    try {
      const response = await HttpService.get(`/spotQuotingTool/${id}`);
      return response;
    } catch (error) {
      console.error("Error fetching spotQuotingTool by ID:", error);
      throw error; // Hatanın üst seviyede yakalanması için fırlatılıyor
    }
  };

  // Shipment güncelleme fonksiyonu
  updateSpotQuotingTool = async (spotQuotingTool, spotQuotingToolId) => {
    const endpoint = `spotQuotingTool/${spotQuotingToolId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, spotQuotingTool); // PUT veya PATCH kullanın
  };




  // Tüm shipment'ları getiren fonksiyon
  getWeeklyShippings = async () => {
    const weeklyShippingsEndpoint = "weeklyShipping";
    return await HttpService.get(weeklyShippingsEndpoint);
  };

  // Belirli bir shipment'ı silen fonksiyon
  deleteWeeklyShipping = async (id) => {
    try {
      const response = await HttpService.delete(`weeklyShipping/${id}`); // /api/shipments olarak güncelledik
      return response;
    } catch (error) {
      console.error("Error deleting weeklyShipping:", error);
      throw error;
    }
  };

  // CrudService.js içinde, sadece numara almak için bir işlev tanımlayın
  getWeeklyShippingNumber = async () => {
    const endpoint = "weeklyShipping/number"; // Numara almak için API endpoint'i belirleyin
    return await HttpService.get(endpoint);
  };

  // Yeni shipment oluşturma
  createWeeklyShipping = async (payload) => {
    const endpoint = "weeklyShipping"; // /api/shipment olarak güncelledik
    return await HttpService.post(endpoint, payload);
  };

  // Belirli bir shipment'ı getiren fonksiyon
  getWeeklyShipping = async (id) => {
    const weeklyShippingsEndpoint = `/weeklyShippings/${id}`; // /api/shipments/{id} olarak güncelledik
    return await HttpService.get(weeklyShippingsEndpoint);
  };

  getWeeklyShippingById = async (id) => {
    if (!id || id.length !== 24) {
      throw new Error("Invalid weeklyShipping ID provided.");
    }

    try {
      const response = await HttpService.get(`/weeklyShipping/${id}`);
      return response;
    } catch (error) {
      console.error("Error fetching weeklyShipping by ID:", error);
      throw error; // Hatanın üst seviyede yakalanması için fırlatılıyor
    }
  };

  // Shipment güncelleme fonksiyonu
  updateWeeklyShipping = async (weeklyShipping, weeklyShippingId) => {
    const endpoint = `weeklyShipping/${weeklyShippingId}`; // Doğru endpoint'e gönderdiğinizden emin olun
    return await HttpService.patch(endpoint, weeklyShipping); // PUT veya PATCH kullanın
  };



 getBankDetails = async (params = {}) => {
    const res = await HttpService.get("bank-detail", { params });
     const payload = res?.data;
    // JSON:API: { data: [{ id, attributes }...] }
       if (Array.isArray(payload?.data)) {
         return payload.data.map(({ id, attributes }) => ({ id, ...(attributes || {}) }));
       }
      // Ham dizi: [{ _id, ... }]
        if (Array.isArray(payload)) {
          return payload.map(x => ({ id: x._id || x.id, ...x }));
         }
     return [];
     };

// Silme
  deleteBankDetail = async (id) => {
    try {
      const res = await HttpService.delete(`bank-detail/${id}`);
      return res;
    } catch (error) {
      console.error("Error deleting bank detail:", error);
      throw error;
    }
  };

  createBankDetail = async (form) => {
    const res = await HttpService.post("bank-detail", { data: form });
    const obj = res?.data?.data;
    return obj ? ({ id: obj.id, ...(obj.attributes || {}) }) : null;
  };


// Tek kayıt getir
  getBankDetail = async (id) => {
    const res = await HttpService.get(`bank-detail/${id}`);
    const obj = res?.data?.data;
    return obj ? ({ id: obj.id, ...obj.attributes }) : null;
  };

// ID ile getir (istersen tek bir isim bırak ve bunu kullan)
  getBankDetailById = async (id) => {
    try {
      const res = await HttpService.get(`bank-detail/${id}`);
      const obj = res?.data?.data;
      return obj ? ({ id: obj.id, ...obj.attributes }) : null;
    } catch (error) {
      console.error("Error in getBankDetailById:", error?.message || error);
      throw error;
    }
  };

// Güncelleme (Meeting’teki gibi body direkt alanları içerir; { bankName, currency, ... })
  updateBankDetail = async (bankDetail, bankDetailId) => {
    const endpoint = `bank-detail/${bankDetailId}`;
    const res = await HttpService.patch(endpoint, bankDetail);
    const obj = res?.data?.data;
    return obj ? ({ id: obj.id, ...obj.attributes }) : null;
  };

// Prefix ile arama (backend Meeting’teki gibi düz dizi döndürür, JSON:API değil)
  getBankDetailsByPrefix = async (prefix) => {
    const endpoint = `bank-detail?prefix=${encodeURIComponent(prefix)}`;
    try {
      const res = await HttpService.get(endpoint);
      return res.data; // düz array
    } catch (error) {
      console.error("Error fetching bank details by prefix:", error?.message || error);
      throw error;
    }
  };


  // tag requests
  getTags = async () => {
    const tagsEndpoint = "tags";
    return await HttpService.get(tagsEndpoint);
  };

  deleteTag = async (id) => {
    const endpoint = `tags/${id}`;
    return await HttpService.delete(endpoint);
  };

  createTag = async (payload) => {
    const endpoint = "tags";
    return await HttpService.post(endpoint, payload);
  };

  getTag = async (id) => {
    const endpoint = `tags/${id}`;
    return await HttpService.get(endpoint);
  };

  updateTag = async (payload, id) => {
    const endpoint = `tags/${id}`;
    return await HttpService.patch(endpoint, payload);
  };

  // item requests
  getItems = async () => {
    const tagsEndpoint = "items";
    return await HttpService.get(tagsEndpoint);
  };

  deleteItem = async (id) => {
    const endpoint = `items/${id}`;
    return await HttpService.delete(endpoint);
  };

  getCategoryOfItem = async (id) => {
    const endpoint = `items/${id}/category`;
    return await HttpService.get(endpoint);
  };

  getTagsOfItem = async (id) => {
    const endpoint = `items/${id}/tags`;
    return await HttpService.get(endpoint);
  };

  createItem = async (payload) => {
    const endpoint = "items";
    return await HttpService.post(endpoint, payload);
  };

  itemImageUpload = async (formData, id) => {
    const imageUpdate = `upload-api/items/${id}/image`;
    return await HttpService.post(imageUpdate, formData);
  };

  getItem = async (id) => {
    const endpoint = `items/${id}?include=category,tags`;
    return await HttpService.get(endpoint);
  };

  updateItem = async (payload, id) => {
    const endpoint = `items/${id}`;
    return await HttpService.patch(endpoint, payload);
  };

  checkCustomerForm = async (formData) => {
    return await HttpService.post("upload-api/check-customer-forms", formData);
  };


  // ==== CERTIFICATES ====

  // Liste
  getCertificates = async () => {
    const endpoint = "certificate"; // backend router: /certificate
    return await HttpService.get(endpoint);
  };

  // Tek kayıt
  getCertificate = async (id) => {
    const endpoint = `certificate/${id}`;
    return await HttpService.get(endpoint);
  };

  // Yükleme / oluşturma (multipart/form-data)
  uploadCertificate = async (formData) => {
    const endpoint = "certificate";
    // formData: { fileName, expireDate, certificate(File) }
    return await HttpService.post(endpoint, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  editCertificate = async (id, payload) => {
    const endpoint = `certificate/${id}`;
    const isFormData = payload instanceof FormData;

    return await HttpService.patch(endpoint, payload, {
      ...(isFormData ? { headers: { "Content-Type": "multipart/form-data" } } : {}),
    });
  };

  // Silme
  deleteCertificate = async (id) => {
    const endpoint = `certificate/${id}`;
    return await HttpService.delete(endpoint);
  };


  createSentRequest = async (payload) => {
    // Backend create body.data bekliyor
    const endpoint = "sent-requests";
    return await HttpService.post(endpoint, { data: payload });
  };

  getSentRequest = async (id) => {
    const endpoint = `sent-requests/${id}`;
    return await HttpService.get(endpoint);
  };

// (Opsiyonel) listelemek istersen:
  getSentRequests = async (params) => {
    const endpoint = "sent-requests";
    return await HttpService.get(endpoint, { params }); // page.size, page.number, filter, sort vb.
  };

// Meeting’deki gibi PATCH kullan (PUT değil) ve body düz obje olsun
  updateSentRequest = async (id, update) => {
    const endpoint = `sent-requests/${id}`;
    return await HttpService.patch(endpoint, update);
  };

  deleteSentRequest = async (id) => {
    const endpoint = `sent-requests/${id}`;
    return await HttpService.delete(endpoint);
  };

  addRecipientsToSentRequest = async (sentRequestId, recipients) => {
    const endpoint = `sent-requests/${sentRequestId}/recipients`;
    return await HttpService.post(endpoint, { recipients });
  };

  getCitiesByCountry = async (country) => {
    if (!country) return { data: { data: [] } };
    const endpoint = `/locations/cities?country=${encodeURIComponent(country)}`;
    return await HttpService.get(endpoint);
  };


  getSeaportsByCountry = async (country) => {
    if (!country) return { data: { data: [] } };
    const endpoint = `/locations/seaports?country=${encodeURIComponent(country)}`;
    return await HttpService.get(endpoint);
  };

  getAirportsByCountry = async (country) => {
    if (!country) return { data: { data: [] } };
    const endpoint = `/locations/airports?country=${encodeURIComponent(country)}`;
    return await HttpService.get(endpoint);
  };


// CrudService.js
  getSeaportsByCountryOpp(country, config = {}) {
    return axios.get("/locations/seaports/opp", {
      ...config,
      params: { ...(config.params || {}), country, _ts: Date.now() },
      headers: { ...(config.headers || {}), "Cache-Control": "no-cache" },
    });
  }


  getAirportsByCountryOpp(country, config = {}) {
    return axios.get("/locations/airports/opp", {
      ...config,
      params: { ...(config.params || {}), country, _ts: Date.now() },
      headers: { ...(config.headers || {}), "Cache-Control": "no-cache" },
    });
  }

  getCitiesByCountryOpp(country, config = {}) {
    return axios.get("/locations/cities", {
      ...config,
      params: { ...(config.params || {}), country, _ts: Date.now() },
      headers: { ...(config.headers || {}), "Cache-Control": "no-cache" },
    });
  }








}

export default new CrudService();
